import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import * as Alerts from "@components/alerts";

const Alert = (): ReactElement => {
  const alerts = useSelector((state: any) => state.Ui.Alert);

  const Components: any = Alerts;

  if (alerts?.length) {
    return (
      <div className="alerts">
        {alerts.map((alert: { alert: any; data: any }, index: number) => {
          const Component = Components[alert.alert];
          return <Component key={index} {...alert.data} />;
        })}
      </div>
    );
  }
  return <></>;
};

export default Alert;
